<template>
  <div>
    <v-app-bar app color="blue darken-2" dark elevate-on-scroll elevation="0" dense>
      <v-avatar size="42">
        <v-icon>mdi-truck-fast</v-icon>
      </v-avatar>

      <v-toolbar-title> Questionario </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-icon left>mdi-calendar</v-icon>
      <span class=""></span> {{ startDate }} • {{ endDate }}

      <v-spacer></v-spacer>

      <!-- <v-btn class="mr-3" disabled text x-large>
      <v-icon dark left> mdi-truck </v-icon>
      <span class="text--white">{{ targa }}</span>
    </v-btn> -->

      <v-spacer></v-spacer>
      <!-- <v-item-group active-class="primary">
      <v-btn dark text :to="{ name: 'survey-detail' }" exact>
        <v-icon left> mdi-file-document-outline </v-icon> Dati
      </v-btn>
      <v-btn dark text class="ml-3" :to="{ name: 'survey-journeys' }" exact>
        <v-icon left> mdi-file-marker-outline </v-icon> Viaggi
      </v-btn>
      <v-btn dark text depressed class="ml-3" :to="{ name: 'survey-document-preview' }" exact>
        <v-icon left> mdi-file-eye-outline </v-icon> ANTEPRIMA
      </v-btn>
    </v-item-group> -->

      <!-- <v-btn @click="goToPreview" icon :disabled="survey.last_page < 1">
        <v-icon>mdi-file-eye-outline</v-icon>
      </v-btn>

      <v-btn icon @click="reset">
        <v-icon>mdi-file-restore-outline</v-icon>
      </v-btn> -->

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to">
            <v-list-item-icon class="mr-4">
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="reset">
            <v-list-item-icon class="mr-4">
              <v-icon v-text="'mdi-file-undo-outline'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Resetta questionario'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- <template v-slot:extension> -->
      <!-- <TheJourneyStepper /> -->
      <!-- <v-icon left>mdi-calendar</v-icon> -->
      <!-- <TheWeekTabs dark /> -->
      <!-- <v-btn text depressed> <v-icon left color="green">mdi-check-all</v-icon>Termina compilazione</v-btn> -->
      <!-- </template> -->
    </v-app-bar>
  </div>
</template>

<script>
// Store
import { mapState } from 'vuex'

// Components

import { createSurveyInstance } from '@/models'

// Third-party libs
import { format, parse } from 'date-fns'
import { it } from 'date-fns/locale'

// Component
export default {
  name: 'TheDefaultAppBar',
  components: {},
  data() {
    return {
      menuItems: [
        // { title: 'Dati azienda (Frontpage)', icon: 'mdi-file-document-outline', to: { name: 'survey-detail' } },
        // { title: 'Viaggi', icon: 'mdi-file-marker-outline', to: { name: 'survey-journeys' } },
        { title: 'Questionario', icon: 'mdi-file-marker-outline', to: { name: 'survey-user' } },
        { title: 'Anteprima questionario', icon: 'mdi-file-eye-outline', to: { name: 'survey-document-preview' } },
      ],
    }
  },
  computed: {
    ...mapState('survey', ['survey']),
    ...mapState('layout', ['weekBar']),
    targa() {
      return this.survey?.vehicle_targa
    },
    startAt() {
      return this.survey?.start_date
    },
    endAt() {
      return this.survey?.end_date
    },
    startDate() {
      return this.survey?.start_date
        ? format(parse(this.survey?.start_date, 'yyyy-MM-dd', new Date()), 'd LLL yyyy', { locale: it })
        : null
    },
    endDate() {
      return this.survey?.end_date
        ? format(parse(this.survey?.end_date, 'yyyy-MM-dd', new Date()), 'd LLL yyyy', { locale: it })
        : null
    },
  },
  methods: {
    async goToPreview() {
      this.$router.push({ name: 'survey-document-preview' })
    },
    async reset() {
      try {
        const confirm = await this.$root.$confirm(
          'Reset questionario',
          'Tutti le informazioni inserite andranno perdute. Resettare il questionario?',
          {
            color: 'success',
          }
        )
        if (confirm) {
          const {
            company,
            referent,
            fleet,
            ownership,
            vehicle_stopped,
            vehicle_fuel_consumed,
            journeys,
            _meta,
            started_at,
            submitted_at,
            updated_at,
            last_page,
          } = createSurveyInstance()
          await this.$store.dispatch('survey/update', {
            id: this.survey.id,
            data: {
              company,
              referent,
              fleet,
              ownership,
              vehicle_stopped,
              vehicle_fuel_consumed,
              journeys,
              last_page,
              _meta,
              started_at,
              submitted_at,
              updated_at,
            },
          })
          await this.$router.push({ name: 'survey-welcome', query: { token: this.survey.id } })
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
